import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { Button } from './Button';
import { CTA_LABEL, scrollToForm } from '../lib/content';
interface CtaButtonProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  label?: string;
}
export function CtaButton({
  size = 'lg',
  className = '',
  label = CTA_LABEL
}: CtaButtonProps) {
  return <Button size={size} onClick={scrollToForm} trailingIcon={<ArrowRightIcon size={18} data-id="element-31" data-mp="qjil5v1sn63m" />} className={className} data-id="element-30" data-mp="cjhhy8y23mkz">
      {label}
    </Button>;
}